module.exports = {
  deliveryComplaintCategoryId: '113',
}
